import Index from '@/pages/standardphone/Index'
import List from '@/pages/standardphone/List'
import Create from '@/pages/standardphone/Create'
import Modify from '@/pages/standardphone/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'standardphone',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'modify/:id',
      component: Modify,
      props: () => ({serviceName: serviceName})
    }
  ]
}

